import { render, staticRenderFns } from "./OpenChatWhatsapp.vue?vue&type=template&id=544c09b9&scoped=true&"
import script from "./OpenChatWhatsapp.vue?vue&type=script&lang=js&"
export * from "./OpenChatWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./OpenChatWhatsapp.vue?vue&type=style&index=0&id=544c09b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544c09b9",
  null
  
)

export default component.exports